import React from 'react';

const features = [
    {name: 'Dashboard', description: "Add the Dashboard Feature to a Vendor", url: "/dashboard"},
    {name: 'Affiliate', description: "Disable Affiliate for a Vendor", url: "/affiliate"},
    {name: 'Platforms', description: "Manage Platform integrations for Vendors", url: "/platform"},
];

const VendorFeatures = () => {
    const handleRedirect = (url) => {
        const baseUrl = window.location.origin + window.location.pathname;
        window.location.href = `${baseUrl}${url}`;
    };

    return (
        <div>
            <main className="sl-main sl-mt-8">
                <div className={"sl-container sl-m-auto sl-my-8"}>

                    <h1 className={`sl-mb-10 sl-text-xl sl-text-gray-900`}>Vendor Features</h1>

                    <div className={`sl-row`}>
                        {features.map((feature, index) => (
                            <div className="sl-col-span-3" key={index}>
                                <div className="sl-h-full sl-font sl-p-8 sl-text-left sl-border sl-border-radius-8 sl-flex sl-flex-col">
                                    <h4 className="sl-mb-2 sl-font-semibold sl-text-gray-900">{feature.name}</h4>
                                    <p className="sl-mb-8">{feature.description}</p>
                                    <button
                                        className="sl-btn sl-btn-primary sl-width-100 sl-p-2"
                                        onClick={() => handleRedirect(feature.url)}
                                    >
                                        Manage
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </main>
        </div>
    );
};

export default VendorFeatures;
